import Image from 'next/image';
import Link from 'next/link';
import { prefix } from '../../lib/auth';
import { useTranslations } from 'next-intl';

const LandingPageHeader = () => {
    const t = useTranslations('landing');
    
    return (
         <div className='max-w-[90%] lg:max-w-[1400px] w-full lg:px-[50px] m-auto '>
            <div className='flex items-center justify-between py-[15px]'>
                <Image src='/images/mail-logo.svg' alt='logo' width={141} height={30} className='h-[30px]' />
                <div className='flex items-center gap-[29px]'>
                    <Link href={`http://${prefix()}accounts.workpeg.com/login?peg=email`} className='text-white-50 text-[16px]'>{t('login')}</Link>
                    {/* <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=email`} className='py-[6px] px-[24px] bg-grey-900  text-white-50 text-[16px] border-[1px] border-[#50565D] rounded-[6px] hidden lg:block'>Create Account</Link> */}
                </div>
            </div>
        </div>
    );
};

export default LandingPageHeader;